import confirmDirtyOptionsAndPerformAction from './confirmDirtyOptionsAndPerformAction';
import showQuickOptionsAction from 'owa-options-actions/lib/showQuickOptions';
import { orchestrator } from 'satcheljs';
import { setIsFullOptionsShown } from 'owa-options-store';
import { hideFullOptions } from 'owa-options-core';

export default orchestrator(hideFullOptions, actionMessage => {
    const continueAfterConfirmCallback = () => {
        setIsFullOptionsShown(false);
        if (actionMessage.showQuickOptions) {
            showQuickOptionsAction();
        }
    };

    confirmDirtyOptionsAndPerformAction(continueAfterConfirmCallback);
});
